import { useEffect, useState } from "react";
import api, { errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";
import { Save, Plus, Trash2, ShieldCheck } from "lucide-react";

/** Admin: who signs level 2 of purchase orders (any one of the slots authorizes). */
export function PoApproversSection() {
  const [slots, setSlots] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/settings/po-approvers").then((r) => setSlots(r.data.slots)).catch(() => {});
    api.get("/users").then((r) => setUsers(r.data.filter((u) => u.active !== false && u.role !== "supplier"))).catch(() => {});
  }, []);

  const setSlot = (i, patch) => setSlots((s) => s.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const save = async () => {
    try {
      const { data } = await api.put("/settings/po-approvers", { slots: slots.map((s) => ({ label: s.label, user_id: s.user_id || "" })) });
      setSlots(data.slots);
      toast.success("Autorizadores de OC guardados");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="border bg-card p-4 space-y-3" data-testid="po-approvers-section">
      <div className="flex items-center justify-between gap-2">
        <div>
          <h3 className="font-black uppercase text-sm tracking-tight flex items-center gap-2"><ShieldCheck size={14} /> Autorización de OC · Nivel 2</h3>
          <p className="text-[11px] text-muted-foreground">Toda OC pasa primero por el encargado del departamento (Departamentos → Autorizadores) y después por cualquiera de estas personas.</p>
        </div>
        <Button size="sm" className="rounded-none text-xs font-bold" onClick={save} data-testid="po-approvers-save"><Save size={12} className="mr-1" /> Guardar</Button>
      </div>
      <div className="space-y-2">
        {slots.map((s, i) => (
          <div key={i} className="grid grid-cols-[1fr_1.5fr_auto] gap-2 items-end" data-testid={`po-approver-slot-${i}`}>
            <div className="space-y-1">
              <Label className="text-[10px] font-bold uppercase tracking-widest">Nombre / puesto</Label>
              <Input value={s.label} onChange={(e) => setSlot(i, { label: e.target.value })} className="rounded-none h-8 text-xs" data-testid={`po-approver-label-${i}`} />
            </div>
            <div className="space-y-1">
              <Label className="text-[10px] font-bold uppercase tracking-widest">Usuario que firma</Label>
              <Select value={s.user_id || "_none"} onValueChange={(v) => setSlot(i, { user_id: v === "_none" ? "" : v })}>
                <SelectTrigger className="rounded-none h-8 text-xs" data-testid={`po-approver-user-${i}`}><SelectValue placeholder="—" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="_none">— Sin asignar —</SelectItem>
                  {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name} · {u.email}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <Button size="sm" variant="ghost" className="rounded-none h-8" disabled={slots.length <= 1}
              onClick={() => setSlots((x) => x.filter((_, j) => j !== i))} data-testid={`po-approver-remove-${i}`}><Trash2 size={13} /></Button>
          </div>
        ))}
        {slots.length < 5 && (
          <Button size="sm" variant="outline" className="rounded-none text-xs" onClick={() => setSlots((x) => [...x, { label: "", user_id: "" }])} data-testid="po-approver-add">
            <Plus size={12} className="mr-1" /> Agregar autorizador
          </Button>
        )}
      </div>
    </section>
  );
}
